import styled from "styled-components";

const Title = styled.h3`
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  margin: 0;
  font-family: 'ProximaNova', sans-serif;
  color: var(--textColor);
`;

const Heading = styled.h2`
  font-size: 36px;
  line-height: 49px;
  font-family: 'ProximaNovaBold', sans-serif;
  color: var(--textColor);
  margin: 0;
`;

const ParagraphBold = styled.p`
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  margin: 0;
  font-family: 'ProximaNova', sans-serif;
  color: var(--textColor);
`;

const Paragraph = styled(ParagraphBold)`
  font-weight: 400;
`;

export { Title, Heading, ParagraphBold, Paragraph };
